module.exports = __webpack_public_path__ + "img/0.9f1a7fb1.png";